import { usePalletsTypes } from 'constants/palletTypes';
import { PalletType, SendPalletDTO } from 'interfaces';

export const getSendPalletTypes = (
   sendPallets: SendPalletDTO[],
   PALLET_TYPE_LABELS: ReturnType<typeof usePalletsTypes>['PALLET_TYPE_LABELS'],
) => {
   const palletTypes = sendPallets.reduce<PalletType[]>((allPalletTypes, sendPalletsItem) => {
      const sendPalletsItemPalletTypes = sendPalletsItem.pallets.map(
         palletItem => palletItem.palletType,
      );
      return [...allPalletTypes, ...sendPalletsItemPalletTypes];
   }, []);
   const uniquePalletTypes = new Set(palletTypes);
   const palletTypeOptions = Array.from(uniquePalletTypes).map(palletType => ({
      label: PALLET_TYPE_LABELS[palletType],
      value: palletType,
   }));
   return palletTypeOptions;
};
